import { useEffect } from "react";
import { WeatherSearchKey } from "../store/weatherSearchDefaults";
import { useAppSelector } from "./useAppSelector";

import { UrlParamsData, writeUrlParams } from "../services/urlParams";

export const useUrlParams = () => {
    const searchProperties = useAppSelector(
        (state) => state.weatherSearch.searchProperties
    );
    const advancedFilter = useAppSelector(
        (state) => state.weatherSearch.advancedFilter
    );
    const bounds = useAppSelector((state) => state.weatherSearch.bounds);
    const zoom = useAppSelector((state) => state.weatherSearch.zoom);
    const excludedProperties = useAppSelector(
        (state) => state.weatherSearch.excludedProperties
    );
    const showMapResultsMobile = useAppSelector(
        (state) => state.weatherSearch.showMapResultsMobile
    );
    const isResponsiveView = useAppSelector(
        (state) => state.weatherSearch.isResponsiveView
    );

    useEffect(() => {
        const data: UrlParamsData = {};
        for (let key in searchProperties) {
            const weatherSearchKey = key as WeatherSearchKey;
            if (excludedProperties.includes(weatherSearchKey)) continue;
            const propertyData = searchProperties[weatherSearchKey];
            data[weatherSearchKey] = propertyData.val.toString();
        }
        const boundsSplitted = bounds
            ? bounds.split(",").map((v) => parseFloat(v))
            : [];
        if (boundsSplitted.length) {
            data["center"] = [
                Math.abs(boundsSplitted[3] - boundsSplitted[1]) / 2,
                Math.abs(boundsSplitted[2] - boundsSplitted[0]) / 2
            ];
        }
        if (!isNaN(zoom)) {
            data["zoom"] = zoom;
        }
        if (!showMapResultsMobile && isResponsiveView) {
            data["center"] = undefined;
            data["zoom"] = undefined;
        }
        data["advancedFilter"] = advancedFilter;
        writeUrlParams(data);
    }, [searchProperties, advancedFilter, bounds, zoom, excludedProperties]);
};
